// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__aPCA1","productName":"Table_productName__1Ko2l"};